webpackJsonp([12,18],{

/***/ 192:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(19);

__webpack_require__(20);

__webpack_require__(18);

__webpack_require__(21);

__webpack_require__(22);

__webpack_require__(8);

__webpack_require__(54);

__webpack_require__(448);

__webpack_require__(25);

__webpack_require__(447);

__webpack_require__(86);

__webpack_require__(15);

var _setupCommonJS = __webpack_require__(16);

var _setupCommonJS2 = _interopRequireDefault(_setupCommonJS);

var _appConfig = __webpack_require__(2);

var _promotionList = __webpack_require__(80);

var _promotionList2 = _interopRequireDefault(_promotionList);

var _generateLinkCard = __webpack_require__(78);

var _generateLinkCard2 = _interopRequireDefault(_generateLinkCard);

var _setCategory = __webpack_require__(220);

var _setCategory2 = _interopRequireDefault(_setCategory);

var _hideLoadingImage = __webpack_require__(14);

var _hideLoadingImage2 = _interopRequireDefault(_hideLoadingImage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _setupCommonJS2.default)();

(0, _promotionList2.default)().then(function (json) {
	json.promotions.forEach(function (item) {
		document.querySelector('.section-block > .content').appendChild((0, _generateLinkCard2.default)(item.id, item.type, item.title, item.date_start, _appConfig.uploadUri + '/' + item.thumb, item.link));
	});
}).then(function () {
	(0, _hideLoadingImage2.default)();
});

(0, _setCategory2.default)(window.location.href.split('#')[1]);

Array.from(document.querySelectorAll('.promotion-category > .item')).forEach(function (item) {
	item.addEventListener('click', function (e) {
		document.querySelector('.content-wrapper').setAttribute('class', 'content-wrapper -' + e.target.getAttribute('class').split('-')[1]);
	});
});

/***/ }),

/***/ 220:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
var setCategory = function setCategory(type) {
	if (type) {
		document.querySelector('.content-wrapper').classList.remove('-all');
		document.querySelector('.content-wrapper').classList.add('-' + type);
	}
};

exports.default = setCategory;

/***/ }),

/***/ 25:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 447:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 448:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 470:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(4);
__webpack_require__(5);
module.exports = __webpack_require__(192);


/***/ }),

/***/ 54:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 78:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _generatePromotionCardBlock = __webpack_require__(79);

var _generatePromotionCardBlock2 = _interopRequireDefault(_generatePromotionCardBlock);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var generateLinkCard = function generateLinkCard(linkId, typeArray, title, date, imageUrl, bookLink) {
	var template = (0, _generatePromotionCardBlock2.default)(title, date, imageUrl, bookLink);

	typeArray.forEach(function (type) {
		template.classList.add('-' + type);
	});
	template.setAttribute('href', 'promotions/' + linkId);

	return template;
};

exports.default = generateLinkCard;

/***/ }),

/***/ 79:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _urlParser = __webpack_require__(9);

var _urlParser2 = _interopRequireDefault(_urlParser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var generatePromotionCardBlock = function generatePromotionCardBlock(title, date, imageUrl, bookLink) {
	var template = document.querySelector('._template-block > .card-block').cloneNode(true);

	template.lastChild.lastChild.innerText = title;
	template.lastChild.firstChild.innerText = date;
	template.firstChild.setAttribute('style', 'background-image: url(' + imageUrl + ')');

	if (bookLink) {
		template.querySelector('.content').innerHTML += '<a href=\'' + bookLink + '\' class=\'book-button\'>' + {
			tw: '預訂',
			en: 'BOOK',
			cn: '预订',
			jp: '予約'
		}[_urlParser2.default.language] + '</a>';
	}

	return template;
};

exports.default = generatePromotionCardBlock;

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 80:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _appConfig = __webpack_require__(2);

var promotionList = function promotionList() {
	var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	return fetch(_appConfig.apiUri + '/promotion' + (type ? '?type=' + type : '')).then(function (res) {
		return res.json();
	}).catch(function (err) {
		return console.error(err);
	});
};

exports.default = promotionList;

/***/ }),

/***/ 86:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[470]);


// WEBPACK FOOTER //
// promotions.323df49080346.js